import LoadingSVG from "../LoadingSvg";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Main, Overlay, SpinStyle } from "./styles";
import { useAppSelector } from "app/store";
import {
  selectStateLoading,
  selectIsTextVisible,
} from "app/store/trackingApp/loadingSlice";

const LoadingComponent: React.FC = () => {
  const state = useAppSelector(selectStateLoading);
  const isTextVisible = useAppSelector(selectIsTextVisible);
  return (
    <>
      {state && (
        <>
          <Main
            $isTextVisible={isTextVisible}
            className="fixed bg-gray-50 flex justify-center flex-wrap z-20 items-center"
          >
            <LoadingSVG />
            {isTextVisible && (
              <div>
                <p className="text-sm mb-3 text-black text-center font-medium">
                  {" "}
                  Esse painel pode levar mais tempo para processar as
                  informações.
                </p>
                <p className="text-sm mb-1 text-black text-center">
                  Não é necessário atualizar a página.
                </p>
                <p className="text-sm mb-1 text-black text-center">
                  Aguarde, o carregamento será concluído.
                </p>
              </div>
            )}
            <div className="w-full loadingTextContent flex justify-center items-center">
              <SpinStyle className="mr-3 mt-1">
                <CircularProgress
                  style={{
                    width: 20,
                    height: 20,
                  }}
                />
              </SpinStyle>
              <p className="text-2xl font-bold mb-1">Carregando</p>
            </div>
          </Main>
          <Overlay className="fixed w-full h-full z-10 top-0 left-0" />
        </>
      )}
    </>
  );
};

export default LoadingComponent;
